


































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component

export default class Pagination extends Vue {
  @Prop()
  itemsCount: number;

  @Prop({ default: 1 })
  page: number;

  @Prop({ default: 5 })
  rowsPerPageCount: number | string;

  get rowsPerPageOptions() {
    return [
      {
        text: '5',
        value: 5,
      },
      {
        text: '10',
        value: 10,
      },
      {
        text: '20',
        value: 20,
      },
      {
        text: this.t('All'),
        value: 'all',
      }
    ]
  }

  get pageStart() {
    if (this.rowsPerPage === 'all') {
      return 1
    }
    return Math.max((this.currentPage - 1) * (this.rowsPerPage as number) + 1, 1)
  }

  get pageEnd() {
    if (this.rowsPerPage === 'all') {
      return this.itemsCount
    }

    return Math.min(this.currentPage * (this.rowsPerPage as number), this.itemsCount)
  }

  get currentPage() {
    return this.page
  }

  set currentPage(val) {
    this.page = val
    this.$emit('update:page', this.page);
  }

  get rowsPerPage() {
    return this.rowsPerPageCount
  }

  set rowsPerPage(val) {
    this.rowsPerPageCount = val === 'all' ? 'all' : +val
    this.currentPage = 1;
    this.$emit('update:rows-per-page-count', this.rowsPerPage);
  }
}
